import { render, staticRenderFns } from "./ConcernPage.vue?vue&type=template&id=6d368f47&scoped=true"
import script from "./ConcernPage.vue?vue&type=script&lang=js"
export * from "./ConcernPage.vue?vue&type=script&lang=js"
import style0 from "./ConcernPage.vue?vue&type=style&index=0&id=6d368f47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d368f47",
  null
  
)

export default component.exports